import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const purchaseOrderCheckQuantityRBAC = {
  pageID: 'b41e96c12b3a66489b7f6efae9b66014',
  elementID: {
    CheckQuantityActions: '3a155a930f5f082b445ad7203c680106',
  },
} as const

export const useRBACPurchaseOrderCheckQuantity = createUseRBAC(
  purchaseOrderCheckQuantityRBAC.elementID,
)
export type UseRBACPurchaseOrderCheckQuantityType = ReturnType<
  typeof useRBACPurchaseOrderCheckQuantity
>
